import React, {useState} from "react";
import {Button, Modal, Form} from "react-bootstrap";
import FalconCloseButton from "../../common/FalconCloseButton";
import {useForm} from "react-hook-form";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import IconButton from "../../common/IconButton";
import PropTypes from "prop-types";
import {selectLang, Translate} from "../../../app/store/reducers/main/mainReducer";
import {useSelector} from "react-redux";


const CancelReturnInvoice = ({cancel, disabled, ...props}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const {register, formState: {errors}, handleSubmit, reset} = useForm();

    const [show, setShow] = useState(false);
    const handleClose = () => {
        reset();
        setShow(false);
    };

    const formSubmit = ({comment}) => {
        cancel({
            comment: comment
        })
        reset();
        setShow(false);
    };

    return (
        <>
        <IconButton
            variant="falcon-danger"
            size="sm"
            icon={faBan}
            disabled={disabled}
            iconClassName="me-1"
            className="mx-1 mb-2 mb-sm-0"
            onClick={() => setShow(true)}
            {...props}
        >{t(lang, "edi.common.cancel_decline")}</IconButton>
            <Modal size="md" show={show} onHide={handleClose}>
                <Form onSubmit={handleSubmit(formSubmit)}>
                    <Modal.Header>
                        <Modal.Title>{t(lang, "edi.common.cancel_decline")}</Modal.Title>
                        <FalconCloseButton onClick={() => {handleClose()}}/>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>{t(lang, "edi.common.label.comment")}</Form.Label>
                            <Form.Control
                                name="Name"
                                as="textarea" rows={3}
                                placeholder={t(lang, "edi.common.modal.reason.placeholder")}
                                isInvalid={errors?.comment?.message}
                                {...register("comment", {
                                    required: {
                                        value: true,
                                        message: t(lang, "edi.common.forms.validations.is_required")
                                    }
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.comment?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {handleClose()}}>{t(lang, "edi.common.cancel_button")}</Button>
                        <Button 
                            variant="danger" 
                            className="d-flex align-items-center" 
                            disabled={disabled}
                            type="submit"
                        >{t(lang, "edi.common.cancel_decline")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

CancelReturnInvoice.propTypes = {
    cancel: PropTypes.func
}

CancelReturnInvoice.defaultProps = {
    cancel: () => {}
}

export default CancelReturnInvoice;